<template lang="html">
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M14.7512 5V0.75L10.5012 0.75M14.7512 0.75L9.75122 5.75" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.5029 14.7515L14.7529 14.7515L14.7529 10.5015M14.7529 14.7515L9.75293 9.75146" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M0.751709 10.5032L0.751709 14.7532L5.00171 14.7532M0.751709 14.7532L5.75171 9.75317" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M5 0.751954L0.750001 0.751953L0.75 5.00195M0.750001 0.751953L5.75 5.75195" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<style lang="css" scoped>
</style>

<script>
export default {
  name: 'IconExpand'
}
</script>
